export enum Color {
  aquaBlue = '#00B1AF',
  aquaBlue20 = '#CCEFEF',
  aquaBlue40 = '#99E0DF',
  aquaBlue60 = '#66D0CF',
  aquaBlue80 = '#33C1BF',
  black = '#000000',
  bloodOrange = '#EE4C14',
  error = '#E7401E',
  error40 = '#FAD9D2',
  freshGreen = '#A9C90E',
  freshGreen20 = '#EEF4CF',
  freshGreen40 = '#DDE99F',
  freshGreen60 = '#CBDF6E',
  freshGreen80 = '#BAD43E',
  gallery = '#EEEEEE',
  grassGreen = '#009A17',
  grassGreen20 = '#CCEBD1',
  grassGreen40 = '#99D7A2',
  grassGreen60 = '#66C274',
  grassGreen80 = '#33AE45',
  lightOrange = '#ED8B00',
  midOrange = '#F06400',
  mist = '#F6F8FB',
  petrolBlue = '#004A5D',
  petrolBlue20 = '#CCDBDF',
  petrolBlue40 = '#99B7BE',
  petrolBlue60 = '#66929E',
  petrolBlue80 = '#336E7D',
  sand = '#F6F6F6',
  steel = '#545656',
  steel20 = '#DDDDDD',
  steel40 = '#BBBBBB',
  steel60 = '#989A9A',
  steel80 = '#767878',
  thunder = '#2D2D2D',
  white = '#FFFFFF',
}

export type ColorNames = keyof typeof Color
